
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import CookiePreferences from '../common/CookiePreferences';

export default function Footer() {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();
    const siteUrl = process.env.REACT_APP_SITE_URL || '';
    const [prefsVisible, setPrefsVisible] = React.useState(false);

    const handleNavigation = (path) => {
        window.location.assign(`${siteUrl}${path}`);
    };

    return (
        <footer className="sistema-fondo-activo text-primary mt-0 border-surface">
            <div className="px-4 lg:px-8 py-4">
                <div className="grid">
                    {/* Logo y descripción */}
                    <div className="col-12 md:col-6 lg:col-3 mb-4">
                        <div className="mb-4">
                            <img
                                src="/logotipo-hor-dark.png"
                                alt="Laptops.pe - La casa de las laptops en Perú"
                                className="mb-3"
                                height={100}
                                style={{ maxWidth: '100%' }}
                            />
                            <p className="text-gray-500 line-height-3 pr-3">
                                <strong>Laptops.pe - La casa de las laptops en Perú</strong><br />
                                Especialistas en venta de laptops, notebooks y accesorios tecnológicos.
                                Envíos a todo el Perú desde nuestros distintos almacenes.
                            </p>
                        </div>

                        {/* Redes sociales */}
                        <div className="flex gap-2">
                            {/* Facebook: laptops.pe */}
                            <Button
                                icon="pi pi-facebook"
                                className="p-button-rounded p-button-outlined p-button-sm bg-white"
                                style={{ color: '#1877f2', borderColor: '#1877f2' }}
                                onClick={() => window.open('https://facebook.com/laptops.pe', '_blank')}
                                tooltip="Síguenos en Facebook"
                            />
                            {/* Instagram: @laptops.pe */}
                            <Button
                                icon="pi pi-instagram"
                                className="p-button-rounded p-button-outlined p-button-sm bg-white"
                                style={{ color: '#e4405f', borderColor: '#e4405f' }}
                                onClick={() => window.open('https://instagram.com/laptops.pe', '_blank')}
                                tooltip="Síguenos en Instagram"
                            />
                            {/* TikTok: @laptops_pe (icono custom) */}
                            <Button
                                className="p-button-rounded p-button-outlined p-button-sm bg-white"
                                style={{ color: '#000000', borderColor: '#000000' }}
                                onClick={() => window.open('https://www.tiktok.com/@laptops_pebydigitalwins', '_blank')}
                                tooltip="Síguenos en TikTok"
                            >
                                {/* SVG TikTok minimal */}
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 3c.4 2 1.7 3.7 3.6 4.5v3.1c-1.4-.1-2.7-.6-3.9-1.3v6.4c0 3.7-3 6.7-6.7 6.7S2.3 19.4 2.3 15.7c0-3.7 3-6.7 6.7-6.7.5 0 1 .1 1.5.2v3.4c-.5-.2-1-.3-1.5-.3-1.8 0-3.3 1.5-3.3 3.4 0 1.9 1.5 3.4 3.3 3.4s3.3-1.5 3.3-3.4V3H16z" />
                                </svg>
                            </Button>
                            {/* YouTube: mantener canal */}
                            {/* <Button 
                                icon="pi pi-youtube" 
                                className="p-button-rounded p-button-outlined p-button-sm"
                                style={{ color: '#ff0000', borderColor: '#ff0000' }}
                                onClick={() => window.open('https://youtube.com/@laptops_pe', '_blank')}
                                tooltip="Suscríbete a nuestro canal"
                            /> */}
                        </div>
                    </div>

                    {/* Enlaces rápidos */}
                    <div className="col-12 md:col-6 lg:col-2 mb-4">
                        <h3 className="text-primary font-semibold mb-4">Catálogo de productos</h3>
                        <ul className="list-none p-0 m-0">
                            <li className="mb-2">
                                <Button
                                    label="Catálogo general"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/catalogo')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Laptops"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/catalogo/laptops')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Cooler"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/catalogo/cooler')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Mouses"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/catalogo/mouses')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Mochilas"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/catalogo/mochilas')}
                                />
                            </li>
                        </ul>
                    </div>

                    {/* Soporte */}
                    <div className="col-12 md:col-6 lg:col-2 mb-4">
                        <h3 className="text-primary font-semibold mb-4">Soporte</h3>
                        <ul className="list-none p-0 m-0">
                            <li className="mb-2">
                                <Button
                                    label="Centro de Ayuda"
                                    className="p-button-text text-seconday p-0 justify-content-start"
                                    onClick={() => handleNavigation('/faq')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Garantías"
                                    className="p-button-text text-seconday p-0 justify-content-start"
                                    onClick={() => handleNavigation('/garantias')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Envíos y Entregas"
                                    className="p-button-text text-seconday p-0 justify-content-start"
                                    onClick={() => handleNavigation('/envios')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Cambios y Devoluciones"
                                    className="p-button-text text-seconday p-0 justify-content-start"
                                    onClick={() => handleNavigation('/cambios-devoluciones')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Medios de pago"
                                    className="p-button-text text-seconday p-0 justify-content-start"
                                    onClick={() => handleNavigation('/medios-pago')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Proceso de compra"
                                    className="p-button-text text-seconday p-0 justify-content-start"
                                    onClick={() => handleNavigation('/proceso-compra')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Eliminar datos de Facebook"
                                    className="p-button-text text-seconday p-0 justify-content-start"
                                    onClick={() => handleNavigation('/eliminar-datos')}
                                />
                            </li>
                        </ul>
                    </div>

                    {/* Empresa */}
                    <div className="col-12 md:col-6 lg:col-2 mb-4">
                        <h3 className="text-primary font-semibold mb-4">Empresa</h3>
                        <ul className="list-none p-0 m-0">
                            <li className="mb-2">
                                <Button
                                    label="Nosotros"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/nosotros')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Contacto"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/contacto')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Términos y Condiciones"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/terminos')}
                                />
                            </li>
                            <li className="mb-2">
                                <Button
                                    label="Política de Privacidad"
                                    className="p-button-text text-secondary p-0 justify-content-start"
                                    onClick={() => handleNavigation('/privacidad')}
                                />
                            </li>
                        </ul>
                        <div className="mt-3 text-secondary text-sm">
                            <p className="m-0"><strong>Laptops.pe</strong> es una marca de <strong>DIGITAL WINS E.I.R.L.</strong></p>
                            <p className="m-0">RUC: <strong>20612859630</strong></p>
                            <p className="m-0">Dirección principal: Av. Ruiseñores 866 Oficina 406 (4to Piso), Santa Anita - Lima - Lima</p>
                        </div>
                        <img
                            src="/libro-reclamaciones.png"
                            alt="Libro de Reclamaciones"
                            className="h-7rem cursor-pointer"
                            onClick={() => window.open('/libro-reclamaciones', '_blank')}
                        />
                    </div>

                    {/* Contacto */}
                    <div className="col-12 md:col-6 lg:col-3 mb-4">
                        <h3 className="text-primary font-semibold mb-4">Contacto</h3>
                        <div className="flex flex-column gap-3">
                            <div className="flex align-items-center">
                                <i className="pi pi-map-marker text-primary mr-3"></i>
                                <div>
                                    <p className="m-0 text-secondary text-sm">
                                        COMPUCENTRO DE SANTA ANITA - Av. Ruiseñores 866 Oficina 406 (4to piso), Santa Anita - Lima - Lima
                                    </p>
                                    <p className="m-0 text-secondary text-xs">
                                        Envíos a todo el Perú
                                    </p>
                                </div>
                            </div>

                            <div className="flex align-items-center">
                                <i className="pi pi-map-marker text-primary mr-3"></i>
                                <div>
                                    <p className="m-0 text-secondary text-sm">Oficinas administrativas: Urb. Brisas de Huachipa Mz. B Lte. 14, Lurigancho, Lima, Lima</p>
                                    <p className="m-0 text-secondary text-xs">
                                    </p>
                                </div>
                            </div>

                            <div className="flex align-items-center">
                                <i className="pi pi-whatsapp text-green-400 mr-3"></i>
                                <div>
                                    <a
                                        href="https://wa.me/51978326796"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-green-400 text-lg font-bold no-underline hover:text-green-600"
                                    >
                                        +51 978 326 796
                                    </a>
                                    <p className="m-0 text-gray-400 text-xs">
                                        WhatsApp - Atención inmediata
                                    </p>
                                </div>
                            </div>

                            <div className="flex align-items-center">
                                <i className="pi pi-envelope text-primary mr-3"></i>
                                <div>
                                    <a
                                        href="mailto:ventas@laptops.pe"
                                        className="text-secondary text-sm no-underline hover:text-primary"
                                    >
                                        ventas@laptops.pe
                                    </a>
                                    <p className="m-0 text-gray-400 text-xs">
                                        Respuesta en 24 horas
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Divider className="m-0" style={{ borderColor: '#374151' }} />

            {/* Copyright */}
            <div className="px-4 lg:px-8 py-4">
                <div className="flex flex-column md:flex-row justify-content-between align-items-center">
                    <div className="text-gray-400 text-sm mb-2 md:mb-0">
                        © {currentYear} Wins. Todos los derechos reservados.
                    </div>

                    <div className="flex align-items-center gap-4">
                        <div className="flex align-items-center gap-2">

                        </div>

                        <div className="flex align-items-center gap-3">
                            <Button
                                label="Preferencias de cookies"
                                className="p-button-text text-secondary"
                                onClick={() => setPrefsVisible(true)}
                            />
                            <div className="text-gray-400 text-xs">
                                Desarrollado por el equipo de Wins
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CookiePreferences visible={prefsVisible} onHide={() => setPrefsVisible(false)} />
        </footer>
    );
}
